<template>
  <div class="visionboard-settings-modal">
    <el-dialog title="Vision Board Settings" :visible.sync="stageSettingsFormVisible">

      <el-row>
        <el-col :span="12">
          <el-form label-width="150px">
            <h4>Visibility</h4>

            <el-form-item label="Show Efforts">
              <el-switch v-model="clone.showAllCommitments">
              </el-switch>
              {{ clone.showAllCommitments ? 'show': 'hide' }}
            </el-form-item>

            <el-form-item label="Show Headlines">
              <el-switch v-model="clone.showAllHeadlines">
              </el-switch>
              {{ clone.showAllHeadlines ? 'show' : 'hide' }}
            </el-form-item>

            <el-form-item label="Show Progress">
              <el-switch v-model="clone.showAllProgress">
              </el-switch>
              {{ clone.showAllProgress ? 'show' : 'hide' }}
            </el-form-item>
          </el-form>
        </el-col>

        <el-col :span="12">
          <el-form label-width="150px">
            <h4>Canvas</h4>

            <el-form-item label="Display visionboard">
              <el-radio-group v-model="clone.canvasScaleMethod">
                <el-radio label="scroll">Scroll</el-radio>
                <el-radio label="fit">Scale to fit</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="Ungroup Items">
              <el-switch
                :disabled="true /*TODO*/"
                v-model="clone.groupItems"
                :active-value="false"
                :inactive-value="true" />
                {{ clone.groupItems ? 'Group Items' : 'Ungroup Items (experimental)' }}
            </el-form-item>

            <el-form-item label="Background color">
              <el-color-picker
                v-model="clone.backgroundColor"
                :predefine="predefinedColors">
              </el-color-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-form label-width="150px">
        <h4>Sizes</h4>

        <el-form-item label="Size of Headlines">
          <el-slider v-model="clone.allHeadlinesFontSize" show-input @change="updateAllHeadlinePositions()"></el-slider>
        </el-form-item>

        <el-form-item label="Size of commitments">
          <el-slider v-model="clone.allCommitmentsFontSize" show-input @change="updateAllCommitmentPositions()"></el-slider>
        </el-form-item>

        <el-form-item label="Stage Width">
          <el-slider v-model="clone.width" show-input :min="480" :max="3840"></el-slider>
        </el-form-item>

        <el-form-item label="Stage Height">
          <el-slider v-model="clone.height" show-input :min="320" :max="2160"></el-slider>
        </el-form-item>
      </el-form>

      <el-form label-width="150px">
        <h4>Export</h4>

        <el-form-item label="Format">
          <el-radio-group v-model="exportSettings.format">
            <el-radio label="image/png">PNG (transparent)</el-radio>
            <el-radio label="image/jpeg">JPEG</el-radio>
            <el-radio label="image/webp">WEBP (Chrome only)</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Quality">
          <el-slider v-model="exportSettings.quality" :disabled="exportSettings.format === 'image/png'" :step="10" style="width: 150px"></el-slider>
        </el-form-item>
        <el-form-item>
          <el-button type="success" plain @click="onExport">Export Visionboard</el-button>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="stageSettingsFormVisible = false">Close</el-button>
        <el-button type="primary" @click="onSaveSettings">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { COLOR_LIST as predefinedColors } from '@/misc/colors'

export default {
  data: () => ({
    predefinedColors: predefinedColors,
    isReady: false,
    stageSettingsFormVisible : false,
    clone: {
      backgroundColor: '#000000',
      canvasScaleMethod: 'scroll',
      groupItems: false,
      width: 1500,
      height: 800,
      allHeadlinesFontSize: 24,
      allCommitmentsFontSize: 15,
      showAllCommitments: true,
      showAllHeadlines: true,
      showAllProgress: true,
      customText: []
    },
    exportSettings: {
      format: 'image/png',
      quality: 90
    }
  }),
  computed: {
    ...mapGetters("user", [
      "userData"
    ]),

  },
  methods: {

    showModal() {
      this.stageSettingsFormVisible = true;
      this.onLoad();
    },

    onLoad() {
      if ( this.userData  && 'visionboardSettings' in this.userData) {
        let settings = this.userData.visionboardSettings;
        this.clone = Object.assign({}, this.clone, settings)

        console.log("onLoad", this.userData, this.clone);
        this.isReady = true;
      } else {
        console.log("onLoad - visionboardSettings dont exist yet");
      }
    },

    onSaveSettings() {
      console.log("onSaveSettings", this.clone);

      this.$api.user_update_settings_by_prefix({
        data: this.clone,
        prefix: 'visionboardSettings'
      }).then(() => {
        console.log( "Successfully updated user visionboardSettings" );
        this.stageSettingsFormVisible = false;
        this.$emit('save', this.clone);
      });
    },

    updateAllHeadlinePositions() {},
    updateAllCommitmentPositions() {},

    /*
    updateAllHeadlinePositions() {
      this.goals.forEach((_, idx) => {
        // update commitment positions
        this.goals[idx].headline.y =  this.goals[idx].image.y - this.stageSettings.allHeadlinesFontSize * 1.2;
        this.goals[idx].headline.x =  this.goals[idx].image.x;
      });
    },

    updateAllCommitmentPositions() {
      this.goals.forEach((_, idx) => {
        this.updateCommitmentPositions(this.goals[idx].goalId);
      });
    },
    */

    onExport() {
      this.stageSettingsFormVisible = false;
      this.$emit('export', this.exportSettings);
    }
  },
  components: {
  }
}
</script>
<style>
.visionboard-settings-modal h4 {
  padding-top: 0.25em;
}
</style>
